import React, {useEffect} from 'react';
import {toast} from 'react-toastify';

export default function FlowMessage({stepData}) {
    const typeMap = {
        'success': 'success',
        'error': 'error',
        'info': 'info',
        'warning': 'warning',
    };

    useEffect(() => {
        if (stepData && stepData.message && typeof stepData.message.text !== 'undefined') {
            toast(stepData.message.text, {
                type: typeMap[stepData.message.type],
            });
        }
    }, [stepData.message]);

    return <React.Fragment></React.Fragment>;
}
